
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.006 13.805h-.633l-.224-.216a5.178 5.178 0 001.257-3.386 5.202 5.202 0 10-10.406 0 5.202 5.202 0 005.203 5.203 5.178 5.178 0 003.386-1.257l.216.224v.633L17.807 19 19 17.807l-3.994-4.002zm-4.803 0a3.597 3.597 0 01-3.602-3.602 3.597 3.597 0 013.602-3.602 3.597 3.597 0 013.602 3.602 3.597 3.597 0 01-3.602 3.602zM8.202 9.803h4.002v.8H8.202v-.8z","fill-rule":"nonzero"}})])
          )
        }
      }
    